module.exports = __webpack_public_path__ + "img/crown_1.94a736cf.svg";